
import {onBeforeMount, Ref, ref, watch} from "vue";
import {useRoute} from "vue-router";
import MessageBox from "../MessageBox.vue";

export default {
  components: { MessageBox },
  props: {
    user: {
      required: true,
      type: Object,
    },
    message: {
      required: true,
      type: String,
    },
    animationIsReverse: {
      required: false,
      type: Boolean,
    },
  },
  setup({user}) {
    const route = useRoute();
    const isTransitionFinished = ref(false);
    const userName: Ref<string> = ref("Usuário");

    onBeforeMount(() => {
      getFirstName();
    })
    /** Reset animations everytime I leave a step. */
    watch(
      () => route.params.step,
      () => {
        if (
          Number(route.params.step) === 5 ||
          Number(route.params.step) === 1
        ) {
          isTransitionFinished.value = false;
        }
      }
    );

    const getFirstName = (): string  => {

      if (user.socialName) {
        return (userName.value = user.socialName);
      } else if (user.name) {
        const endOfFirstName = user.name.indexOf(" ");
        return (userName.value = user.name.slice(0, endOfFirstName));
      }
      return userName.value;
    };

    const fluctuate = (): void => {
      if (!isTransitionFinished.value) {
        isTransitionFinished.value = true;
      }
    };

    return {
      isTransitionFinished,
      userName,
      getFirstName,
      fluctuate,
    };
  },
};
